/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DokanItemLabelsByStatus from '../../components/filter/DokanItemLabelsByStatus';
// eslint-disable-next-line import/no-extraneous-dependencies
// import dotenv from 'dotenv/config';
import http from '../../utils/http';
import { fetchProductsSummary } from '../../redux/products/productsActions';
import DokanDatepicker from '../../components/common/DokanDatepicker';
import DokanItemCategoryFilter from '../../components/filter/DokanItemCategoryFilter';
import Search from '../../components/search/Search';

function changeStatusTitle(status) {
    switch (status) {
        case 'publish':
            return 'online'.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
        case 'total':
            return 'all'.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());

        default:
            return status.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    }
}
function ProductFilters() {
    // accessing state
    const { productsSummary } = useSelector((state) => state.products);

    // dispatch actions
    const dispatch = useDispatch();

    const productFilters = useMemo(() => {
        const makeArrayOfObject = Object.keys(productsSummary ?? {}).map((status) =>
            Object.create(
                {},
                {
                    title: { value: changeStatusTitle(status) },
                    key: { value: status },
                    value: { value: productsSummary[status] },
                }
            )
        );

        // eslint-disable-next-line array-callback-return
        const availableFilters = makeArrayOfObject.filter((item) => item.value !== 0);

        return availableFilters.sort((a, b) => (a.name > b.name ? 1 : -1));
    }, [productsSummary]);

    // component mount...
    useEffect(() => {
        dispatch(fetchProductsSummary());
    }, [dispatch]);
    // consoling results

    return (
        <>
            <div className="flex justify-between">
                <div>
                    {productFilters.map((label) => (
                        <DokanItemLabelsByStatus
                            label={label}
                            key={label.key}
                            queryParameterKey="status"
                            queryParameterValue={label.key}
                            defaultActiveLabel="total"
                        />
                    ))}
                </div>

                <div className="text-sm text-primary ">
                    {/* <DokanDatepicker /> */}
                    <div className="flex justify-between">
                        <DokanItemCategoryFilter />
                        {/* <div>anothr filter category</div> */}
                        <Search />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductFilters;
